import React from "react";
import { useTranslationStrings } from "./TranslationStringsContext";

export const useString = (id: string, fallback?: string): string => {
  const translationStrings = useTranslationStrings();
  let result = translationStrings[id];
  if (!result) {
    result = fallback || id;
  }
  return result;
};

const GetText = ({ id, fallback }: { id: string; fallback?: string }) => {
  const result = useString(id, fallback);
  return <span>{result}</span>;
};

export default GetText;
